
// / Exception thrown when an illegal operation is executed.
export class IllegalOperationException extends Error {
  constructor(
    public readonly description: string,
  ) {
    super(description);
  }

  toString(): string {
    return this.description;
  }
}
